/**
 * 4.3.12 walkthrough slides.
 *
 * Each slide:
 *   {
 *     image:          public-path string (e.g. '/walkthroughs/4.3.12/foo.png'),
 *     title:          short heading,
 *     body:           one or two sentences describing the change,
 *     minRoleWeight?: integer — only users with role_weight >= this see the slide
 *                     (matches hasMinRole gating; omit for "visible to everyone")
 *     is_cloud_only?: boolean — true hides the slide on 4.0 campuses, for features
 *                     that only exist on the 5.0 cloud architecture. Omitted or
 *                     false means architecture-independent. Evaluated against the
 *                     campus config's `is_cloud` in collectSlides (index.js).
 *     is_grandstream?: boolean — true shows the slide only on Grandstream (intercom)
 *                     campuses, the same check that shows the Call Logs report.
 *     is_ehr_integration?: boolean — true shows the slide only where the EHR Tasks
 *                     page, and its History tab, is available (see index.js).
 *   }
 *
 * Drop walkthrough images under public/walkthroughs/{version}/.
 */
export default [
  {
    image: '/walkthroughs/4.3.12/slide1.png',
    title: 'Dashboard Added Context',
    body: 'The average stat cards on the dashboard now contains additional context information to better highlight what is, and is not, included in the averages calculations.',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10,
    is_cloud_only: true,
    is_grandstream: true
  },{
    image: '/walkthroughs/4.3.12/slide2.png',
    title: 'EHR Task Reporting',
    body: 'EHR tasks can now be scheduled to be delivered directly to your inbox, scoped directly for the tasks you need to approve. Save time needlessly logging in, head to reports and select EHR Tasks to begin scheduling.',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10,
    is_cloud_only: false,
    is_ehr_integration: true
  }
];
